module.exports = __webpack_public_path__ + "img/new_23.cd88aebf.jpg";